import React, {useMemo, useState} from 'react'
import {DigitalVosFormModal} from './DigitalVosFormModal'
import type {BuildDigitalVosFormInput} from './digitalVosFormTypes'

export type DigitalVosFormViewerProps = {
  input: BuildDigitalVosFormInput
  fileName: string
  previewText?: string
}

export const DigitalVosFormViewer: React.FC<DigitalVosFormViewerProps> = ({
  input,
  fileName,
  previewText = 'View VOS Form',
}) => {
  const [showModal, setShowModal] = useState(false)

  const modalInput = useMemo(() => input, [
    input.appointment,
    input.meetingSummary,
    input.extensions,
    input.osiNotes,
  ])

  return (
    <>
      <div className='btn-group'>
        <button
          type='button'
          className='btn btn-outline-secondary btn-sm text-primary'
          onClick={() => setShowModal(true)}
        >
          <i className='bi bi-eye me-2 text-primary' />
          {previewText}
        </button>
      </div>

      <DigitalVosFormModal
        show={showModal}
        onClose={() => setShowModal(false)}
        fileName={fileName}
        input={modalInput}
      />
    </>
  )
}
